import { Moon, Sun } from '@phosphor-icons/react';
import { site } from '../../content/site';
import { useTheme } from '../../lib/useTheme';

/** Both glyphs stay mounted and cross-fade with a small turn (collapsed by the global reduced-motion rule). */
const GLYPH = 'col-start-1 row-start-1 transition-[transform,opacity] duration-500 ease-expo';

/**
 * Light / dark switch: a 44px round button using the --nav-* tokens, so it reads on the
 * pill, on the mobile sheet and at dusk. The label names the action, not the state.
 * Moon = "switch to dark" (shown in light), Sun = "switch to light" (shown in dark).
 */
export function ThemeToggle({ className = '' }: { className?: string }) {
	const { theme, toggle } = useTheme();
	const dark = theme === 'dark';

	return (
		<button
			type="button"
			onClick={toggle}
			aria-label={dark ? site.nav.theme.toLight : site.nav.theme.toDark}
			className={`grid h-11 w-11 shrink-0 place-items-center rounded-full text-[color:var(--nav-ink)] transition-colors duration-300 hover:bg-[color:var(--nav-border)] active:scale-[0.96] ${className}`}
		>
			<Moon
				aria-hidden
				size={20}
				className={`${GLYPH} ${dark ? '-rotate-90 scale-50 opacity-0' : 'rotate-0 scale-100 opacity-100'}`}
			/>
			<Sun
				aria-hidden
				size={20}
				className={`${GLYPH} ${dark ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-50 opacity-0'}`}
			/>
		</button>
	);
}
